import React, { Component } from 'react';
import { connect } from 'react-redux';

import Order from '../../components/Order/Order';
import axios from '../../axios-orders';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler'
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actionCreator from '../../store/actions/index';


class Orders extends Component {

    componentDidMount() {
        this.props.fecthingOrders(this.props.token,this.props.userId);
    }

    render() {
        let orderlist = this.props.loading ? <Spinner /> : (
            <div>
                {this.props.orders.map(order => {
                    return <Order key={order.id}
                        ingredients={order.ingredients}
                        price={order.price} />
                })}
            </div>
        );
        return orderlist;
    }
}

const mapStateToProps = state => {
    return {
        orders: state.order.orders,
        loading: state.order.loading,
        token:state.auth.token,
        userId:state.auth.userId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fecthingOrders: (token,userId) => dispatch(actionCreator.fetchOrders(token,userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Orders, axios));


// WEBPACK FOOTER //
// ./src/containers/Orders/Orders.js